export default {
  posts: [],
};
